import { Button, Icon, Text, Tooltip, TooltipContent, TooltipTrigger, cn } from '@flatfile/baseline'
import { StatsUI } from '../../pages/CustomApps/utilities/customAppHelpers'

export function StatsGrid({ data }: { data: StatsUI[] }) {
  const stats = data.map((stat) => {
    const isPositiveDiff = stat.diff && stat.diff > 0

    return (
      <div key={stat.title} className='border p-4 bg-white shadow-sm min-w-[154px]'>
        <div className='flex justify-between items-center'>
          <div className='flex items-center truncate mr-2'>
            <Text className='text-xs font-medium text-text-default truncate'>{stat.title}</Text>
            <Tooltip>
              <TooltipTrigger asChild>
                <Button
                  variant='ghost'
                  size='icon-sm'
                  className='p-0 h-auto ml-1 flex-shrink-0'
                  icon='circle-info'
                  iconProps={{ size: 12, className: 'text-text-default' }}
                />
              </TooltipTrigger>
              <TooltipContent className='flex items-center px-2 py-1 !max-w-[400px]'>
                <Text variant='body' className='text-sm'>
                  {stat.tooltip}
                </Text>
              </TooltipContent>
            </Tooltip>
          </div>
          <Icon name={stat.icon} size={18} className='text-text-default flex-shrink-0' />
        </div>

        <div className='flex flex-wrap items-end gap-2 mt-2'>
          <Text className='text-xl font-bold'>{stat.value}</Text>
          {stat.desc && <Text className='text-xs mt-1 break-words'>{stat.desc}</Text>}
          {stat.diff ? (
            <>
              <div className='flex items-center flex-shrink-0'>
                <Text className={cn('text-sm font-medium', isPositiveDiff ? 'text-emerald-600' : 'text-red-600')}>
                  <span>{stat.diff}%</span>
                  <Icon name={isPositiveDiff ? 'arrow-up' : 'arrow-down'} size={16} className='inline ml-1' />
                </Text>
              </div>
              <Text className='text-xs text-text-default mt-1 text-right w-full'>compared to previous 30 days</Text>
            </>
          ) : (
            <Text className='text-xs text-text-default mt-1 text-right w-full'>rolling 30 days</Text>
          )}
        </div>
      </div>
    )
  })

  return (
    <div className='overflow-x-auto'>
      <div className='grid grid-cols-2 lg:grid-cols-4 gap-3 mt-4 mx-2'>{stats}</div>
    </div>
  )
}
